/* Excluded urls list. Add an endpoint to the array to prevent auth token
 from adding to a request */
export const OMITTED_URLS = [
  'v1/tokenAuth',
  'v1/users/credentials',
  'v1/anonymous/users/resendactivationemail',
];
